// MUI components and utilities
import { Box, Typography, styled, useTheme } from '@mui/material';
// Custom spinner component
import HDSpinner from '../hd-ui-kit/HDSpinner';
import React from 'react';

/**
 * Loader component displays a fullscreen loading spinner overlay.
 * Optionally shows a note below the spinner.
 *
 * @param props -
 *   sx: additional style overrides for the wrapper
 *   showNote: boolean to show a note below the spinner
 *   noteText: text to display as the note
 */
function Loader(props: any) {
  // Detect dark mode for background color
  const isDarkTheme = useTheme().palette.mode === 'dark';
  // Styled wrapper for the loader overlay
  const LoaderWrap = styled(Box)(() => ({
    position: 'fixed',
    height: '100%',
    width: '100%',
    background: isDarkTheme ? 'rgba(0, 33, 54, 1)' : '#fff',
    opacity: '0.9',
    zIndex: 999,
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    flexDirection: 'column',
  }));

  return (
    // Loader overlay with optional custom styles
    <LoaderWrap sx={props?.sx}>
      {/* Main spinner */}
      <HDSpinner size={'la-2x'} buttonColor={false} />
      {/* Optional note below spinner */}
      {props?.showNote ? <Typography sx={{ marginTop: '20px', fontWeight: 700 }}>{props?.noteText}</Typography> : ''}
    </LoaderWrap>
  );
}

// Export the Loader component as default
export default Loader;
